<a
    *ngIf="!isset"
    [href]="loginUrl"
    class="message--module-inactive message--module-inactive--teamleader"
    (click)="activeModal.dismiss()">
    <strong>You are not logged in with Teamleader.</strong>
    <small>Click to connect your account.</small>
</a>
